import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { AdminFormGroup, ICompany, IUser } from "../../../models";

export class UserForm extends AdminFormGroup {
  id = this.get('id') as FormControl;
  companyId = this.get('companyId') as FormControl;
  firstName = this.get('firstName') as FormControl;
  lastName = this.get('lastName') as FormControl;
  imageUrl = this.get('imageUrl') as FormControl;
  alias = this.get('alias') as FormControl;
  email = this.get('email') as FormControl;
  isActive = this.get('isActive') as FormControl;
  
  companyOptions: ICompany[] | null;


  constructor(readonly user: IUser, private companies: ICompany[] | null, readonly fb: FormBuilder = new FormBuilder()) {
    super(fb.group({
      id: [user?.id, Validators.required],
      firstName: [user?.firstName, Validators.required],
      lastName: [user?.lastName, Validators.required],
      companyId: [user?.companyId, Validators.required],
      imageUrl: [user?.imageUrl],
      alias: [user?.alias],
      email: [user?.email],
      isActive: [user?.isActive]
    }).controls);
    this.companyOptions = companies;
  }

  getItem(): IUser {

    var user = {
      id: this.id.value,
      firstName: this.firstName.value,
      lastName: this.lastName.value,
      companyId: this.companyId.value,
      alias: this.alias.value,
      imageUrl: this.imageUrl.value,
      email: this.email.value,
      isActive: this.isActive.value
    };

    return user;
  }

}
